import { toast } from "react-toastify";
import { Rating } from "./Rating";
import { useState } from "react";
import axiosInstanceAuth from "../../apiInstances/axiosInstanceAuth";
import { FiInfo } from "react-icons/fi";
import { IoArrowBack } from "react-icons/io5";

export const PropertyEnquiry = ({ agentData, id }) => {
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);

  const [formData, setFormData] = useState({
    message: "",
    helpWith: [],
  });

  const [personalData, setPersonalData] = useState({
    mobile_no: "",
    first_name: "",
    last_name: "",
    email: "",
  });

  const helpOptions = [
    "Scheduling an inspection",
    "Price information",
    "Rates and fees",
    "Finding similar properties",
  ];

  const handleMessageChange = (e) => {
    setFormData({ ...formData, message: e.target.value });
  };

  const handleCheckboxChange = (option) => {
    if (formData.helpWith.includes(option)) {
      setFormData({
        ...formData,
        helpWith: formData.helpWith.filter((item) => item !== option),
      });
    } else {
      setFormData({
        ...formData,
        helpWith: [...formData.helpWith, option],
      });
    }
  };

  const handleNextStep = () => {
    if (!formData.message.trim()) {
      toast.error("Please enter your question");
      return;
    }
    setStep(2);
  };

  const handlePersonalChange = (e) => {
    const { name, value } = e.target;
    setPersonalData((prev) => ({ ...prev, [name]: value }));
  };

  const SubmitRequest = async () => {
    if (!personalData.mobile_no.trim()) {
      toast.error("Please enter your mobile number");
      return;
    }

    if (!personalData.first_name.trim()) {
      toast.error("Please enter your first name");
      return;
    }

    if (!personalData.last_name.trim()) {
      toast.error("Please enter your last name");
      return;
    }



    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!personalData.email.trim() || !emailRegex.test(personalData.email.trim())) {
      toast.error("Please enter a valid email address");
      return;
    }

    try {
      setLoading(true);

      const res = await axiosInstanceAuth.post("sendEnquiry", {
        property_id: id,
        agent_id: agentData?.id,
        message: formData.message,
        help_with: formData.helpWith,
        mobile_no: personalData.mobile_no,
        first_name: personalData.first_name,
        last_name: personalData.last_name,
        email: personalData.email,
      });

      if (res?.data?.status) {
        toast.success("Enquiry Submitted Successfully");
        setFormData({ message: "", helpWith: [] });
        setPersonalData({
          mobile_no: "",
          first_name: "",
          last_name: "",
          email: "",
          name: "",
        });
        setStep(1);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
      {/* Top Brand Bar */}
      <div
        className={`py-4 text-center ${agentData?.primary_color ? "" : "bg-black"}`}
        style={agentData?.primary_color ? { backgroundColor: agentData.primary_color } : undefined}
      >
        <img
          src={agentData?.agencyLogo}
          alt="Agency"
          className="h-8 mx-auto object-contain"
        />
      </div>

      <div className="p-8">
        {/* Title */}
        {step === 1 ? (
          <h2 className="text-2xl font-semibold text-gray-900 mb-6">
            What would you like to ask the agents?
          </h2>
        ) : (
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-2xl font-semibold text-gray-900">
              Your contact details
            </h2>
            <div
              onClick={() => setStep(1)}
              className="flex items-center cursor-pointer gap-1 text-sm text-[#097FE6]"
            >
              <IoArrowBack className="w-4 h-4" />
              <span>Back</span>
            </div>
          </div>
        )}

        {/* Agent Row */}
        <div className="flex items-center gap-4 mb-6">
          <img
            src={agentData?.profileImg}
            alt="Agent"
            className="w-12 h-12 rounded-full object-cover"
          />
          <div>
            <div className="font-semibold text-gray-900">{agentData?.name}</div>
            <div className="flex items-center gap-2 text-sm text-gray-500">
              <Rating rating={agentData?.average} size={14} />
              <span>
                {agentData?.average?.toFixed(1)} ({agentData?.reviewCount || 0}{" "}
                reviews)
              </span>
            </div>
          </div>
        </div>

        {step === 1 ? (
          <>
            {/* Textarea */}
            <textarea
              rows="6"
              value={formData.message}
              onChange={handleMessageChange}
              placeholder="What would you like to ask the agent?"
              className="w-full border border-gray-300 rounded-xl p-4 focus:outline-none focus:ring-2 focus:ring-[#097FE6]"
            />

            {/* Info Box */}
            <div className="mt-4 bg-blue-50 border border-blue-200 text-blue-700 rounded-xl p-4 text-sm flex items-center gap-2">
              <FiInfo className="w-4 h-4" />
              <span>
                Add more detail to help the agents understand exactly what you need.
              </span>
            </div>

            {/* Help Section */}
            <div className="mt-6">
              <h3 className="font-semibold text-gray-900 mb-4">
                What would you like help with?
              </h3>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-gray-700">
                {helpOptions.map((option) => (
                  <label
                    key={option}
                    className="flex items-center gap-3 cursor-pointer"
                  >
                    <input
                      type="checkbox"
                      checked={formData.helpWith.includes(option)}
                      onChange={() => handleCheckboxChange(option)}
                      className="w-4 h-4 accent-[#097FE6]"
                    />
                    {option}
                  </label>
                ))}
              </div>

              <div className="mt-4 text-xs text-gray-400 flex items-center gap-2">
                <FiInfo className="w-4 h-4" />
                <span>This data is shared with a third party</span>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <div className="font-medium text-gray-900 text-sm mb-2">
                  First name
                </div>
                <input
                  type="text"
                  name="first_name"
                  value={personalData.first_name}
                  onChange={handlePersonalChange}
                  placeholder="Enter your first name"
                  className="w-full border border-gray-300 rounded-xl p-4 focus:outline-none focus:ring-2 focus:ring-[#097FE6]"
                />
              </div>
              <div>
                <div className="font-medium text-gray-900 text-sm mb-2">
                  Last name
                </div>
                <input
                  type="text"
                  name="last_name"
                  value={personalData.last_name}
                  onChange={handlePersonalChange}
                  placeholder="Enter your last name"
                  className="w-full border border-gray-300 rounded-xl p-4 focus:outline-none focus:ring-2 focus:ring-[#097FE6]"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

              <div className="mt-4">
                <div className="font-medium text-gray-900 text-sm mb-2">
                  Email
                </div>
                <input
                  type="email"
                  name="email"
                  value={personalData.email}
                  onChange={handlePersonalChange}
                  placeholder="Enter your email"
                  className="w-full border border-gray-300 rounded-xl p-4 focus:outline-none focus:ring-2 focus:ring-[#097FE6]"
                />
              </div>

              <div className="mt-4">
                <div className="font-medium text-gray-900 text-sm mb-2">
                  Mobile number
                </div>
                <input
                  type="tel"
                  name="mobile_no"
                  value={personalData.mobile_no}
                  onChange={handlePersonalChange}
                  placeholder="Enter your mobile number"
                  className="w-full border border-gray-300 rounded-xl p-4 focus:outline-none focus:ring-2 focus:ring-[#097FE6]"
                />
              </div>

            </div>


          </>
        )}

        {/* Next Button */}
        {step === 1 ? (
          <button
            onClick={handleNextStep}
            disabled={loading}
            className="mt-8 w-full bg-[#097FE6] text-white py-4 rounded-full font-semibold text-lg hover:bg-[#0866c2] transition disabled:opacity-60"
          >
            {loading ? "Submitting..." : "Next"}
          </button>
        ) : (
          <>
            <button
              onClick={SubmitRequest}
              disabled={loading}
              className="mt-5 w-full bg-[#097FE6] text-white py-4 rounded-full font-semibold text-lg hover:bg-[#0866c2] transition disabled:opacity-60"
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </>
        )}
      </div>
    </div>
  );
};
